import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFloorsService } from '../../interfaces/services/floors-service.interface';
import { Floor } from '../../interfaces/state/entities/floor.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FloorsService implements IFloorsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.MayaTestToolApiBaseUrl}/Floors`;

  getFloors(projectId: string): Observable<Floor[]> {
    const params = new HttpParams().set('ProjectId', projectId);
    return this.http.get<{ floors: any[] }>(this.apiUrl, { params }).pipe(
      map((response) =>
        (response.floors ?? []).map((f) => ({
          id: f.floorId,
          projectId: projectId,
          name: f.floorName,
          currentRevision: f.currentRevision ?? 0,
          dateCreated: new Date(f.createdAt),
        }))
      )
    );
  }

  addFloor(projectId: string, name: string): Observable<Floor> {
    return this.http.post<{ floorId: string }>(this.apiUrl, {
      ProjectId: projectId,
      FloorName: name,
    }).pipe(
      map((response) => ({
        id: response.floorId,
        projectId,
        name,
        currentRevision: 0,
        dateCreated: new Date(),
      }))
    );
  }

  deleteFloor(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  getFloorCountByProject(projectId: string): number {
    return 0;
  }
}
